import { render, staticRenderFns } from "./ShippingsInput.vue?vue&type=template&id=53bec7c5&lang=pug"
import script from "./ShippingsInput.vue?vue&type=script&lang=js"
export * from "./ShippingsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports